import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css`
  .RejectModal__content {
    width: 450px;
  }

  .EditCountryForm {
    &__revoke {
      margin-bottom: 15px;
      display: flex;
      justify-content: end;
    }
    &__btns {
      display: flex;
      :global(.DefaultButton) {
        margin-right: ${isRTL ? '0' : '15px'};
        margin-left: ${isRTL ? '15px' : '0'};
      }

      :global(.DefaultButton:last-child) {
        margin-left: auto;
        text-transform: unset;
      }
    }
  }
`;

export default staticStyles;
